





























































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { BookingDetailsModule } from '@/store/modules/bookingDetails';
import JobWorkerDto from '@/models/JobWorkers/JobWorkerDto';
import SelectableEntity from '@/models/Shared/SelectableEntity';
import GiganautVue from '@/components/Shared/GiganautVue';
import { JobDetailsModule } from '@/store/modules/jobDetails';
import JobWorkerStatus from '@/models/JobWorkers/JobWorkerStatus';
import SendJobWorkersToContactRequest from '@/models/JobWorkers/SendJobWorkersToContactRequest';

@Component({
    name: 'JobInterestedWorkersSendToContact'
})
export default class extends GiganautVue {
 
  public jobWorkers: SelectableEntity<JobWorkerDto>[] = [];
  public selectedJobWorkerIds: string[] = [];
  public emailBccUser = false;
  public dialog = false;
  
  @Watch('dialog')
  onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.selectedJobWorkerIds = [];
      
      this.jobWorkers =  this.interestedJobWorkers.map(function(jobWorker: JobWorkerDto) {
        return new SelectableEntity<JobWorkerDto>(jobWorker);
      });
    }
  }

  get loading() {
    return JobDetailsModule.loadingDialog;
  }

  get interestedJobWorkers() {
      return JobDetailsModule.jobWorkersVM.jobWorkers.filter(
        jobWorker => jobWorker.status === JobWorkerStatus.WorkerInterested
      )
  }

  async updateSelectedJobWorkers(val: boolean, jobWorker: JobWorkerDto) {
    	if (val) {
			  this.selectedJobWorkerIds.push(jobWorker.id);
		} else {
			  const index = this.selectedJobWorkerIds.indexOf(jobWorker.id);
        this.selectedJobWorkerIds.splice(index, 1); 
		}
	}

  async send() {  
    const request = new SendJobWorkersToContactRequest();
    request.emailBccUser = this.emailBccUser;
    request.jobWorkerIds = this.selectedJobWorkerIds;
    await JobDetailsModule.sendWorkersToContact(request);
    this.dialog = false;
  }
}
